import {JwtToken} from "../../types";

export function parseJwt(token: JwtToken): { username: string; is_admin: boolean, role: string } {
    const base64Url = (token as string).split('.')[1];
    const base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(base64);
}
